import clsx from 'clsx';

interface PageMainCardProps {
    children: React.ReactNode;
}

const PageMainCard = ({ children }: PageMainCardProps) => {
    const classes = clsx(
        'mx-auto',
        'bg-white',
        'p-2',
        'md:p-8',
        'drop-shadow-lg',
        'max-w-[1100px]',
        'w-full',
        'rounded-lg',
        'my-8'
    );
    return (
        <div className={classes} data-component="PageMainCard">
            {children}
        </div>
    );
};

export default PageMainCard;
